import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { logFunctions as log } from "../../util/Logging";

export default function AlertDialog(props) {
  log.debug("+AlertDialog(TRACE)");

  const { t } = useTranslation("translation");
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    props.inputEl.current.focus();
  });

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
    props.onButtonClick();
  }

  const CustomizedButton = styled(Button)`
    color: #1b76d4;
    font-weight: 600;
  `;

  const CustomizedDialogTitle = styled(DialogTitle)`
    color: black;
  `;

  const CustomizedDialogContentText = styled(DialogContentText)`
    color: black;
  `;

  log.debug("-AlertDialog(TRACE)");
  return (
    <div>
      <CustomizedButton
        onClick={() => handleClickOpen()}
        id="dontHaveQRCodeButtonLabel"
      >
        {t("Don't have a QR Code?")}
      </CustomizedButton>
      <Dialog
        open={open}
        onClose={() => handleClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <CustomizedDialogTitle id="alert-dialog-title">
          {t("Don't have a QR Code?")}
        </CustomizedDialogTitle>
        <DialogContent>
          <CustomizedDialogContentText id="alert-dialog-description">
            {t(
              "Please contact your software administrator or NCR to obtain the QR Code"
            )}
          </CustomizedDialogContentText>
        </DialogContent>
        <DialogActions>
          <CustomizedButton
            onClick={() => handleClose()}
            id="alertDialogAgreeLabel"
          >
            {t("Agree")}
          </CustomizedButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
